import { ITakerAndToYouBranches, ITakerBranch, IToYouBranch } from '~/types/integrations';

const mapBranches = <T>(branches: any[], mapper: (branch: any) => T): T[] => (Array.isArray(branches) ? branches.map(mapper) : []);

export const takerToYouBranchesDTO = (data: any): ITakerAndToYouBranches => {
  return {
    taker_branches: mapBranches<ITakerBranch>(data?.taker_branches, (branch) => ({
      id: Number(branch.id) || 0,
      name: String(branch.name ?? ''),
      address: branch.address ?? null,
      external_id: branch.external_id ? Number(branch.external_id) || null : null,
    })),
    to_you_branches: mapBranches<IToYouBranch>(data?.to_you_branches, (branch) => ({
      id: String(branch.id),
      name: String(branch.name ?? ''),
      formated_address: branch.formated_address ?? null,
      taker_branch_id: branch.taker_branch_id ? Number(branch.taker_branch_id) || null : null,
    })),
  };
};
